import { render } from "./wishBox_edit.vue?vue&type=template&id=23762dbc&scoped=true"
import script from "./wishBox_edit.vue?vue&type=script&lang=js"
export * from "./wishBox_edit.vue?vue&type=script&lang=js"

import "./wishBox_edit.vue?vue&type=style&index=0&id=23762dbc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23762dbc"]])

export default __exports__